// extracted by mini-css-extract-plugin
module.exports = {"wall-of-text-page":"page_wall-of-text-page__6MgJa"};